import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Form, Input, Radio, Button, message, Spin } from "antd";
import BackRouteButton from "src/common/components/BackRouteButton";
import { PlusOutlined } from "@ant-design/icons";

export default ({ createCategory, profile }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const onFinish = async (values) => {
    setLoading(true);
    values.creatorId = profile._id;
    var result = await createCategory(values);
    form.resetFields();

    if (result.success) {
      message.success("New category successfully added!");
      history.goBack();
    } else {
      message.error(result.message || "Error adding category!");
      setLoading(false);
    }
  };

  return (
    <div className="common-container">
      <Spin spinning={loading}>
        <BackRouteButton />
        <h4 className="common-title--large">Add New Warehouse Category</h4>
        <Form
          requiredMark={false}
          layout="vertical"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item
            label="Category Name"
            name="title"
            rules={[
              {
                required: true,
                message: "Please enter the category name!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            requiredMark="hidden"
            label="Category Type"
            name="type"
            rules={[
              { required: true, message: "Please select the category type!" },
            ]}
          >
            <Radio.Group>
              <Radio value="product">Product</Radio>
              <Radio value="rawMaterial">Raw Material</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item>
            <Button htmlType="submit" loading={loading}>
              <PlusOutlined /> Add Category
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </div>
  );
};
